<template>
<div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="gb"  
      :gotodownload="gotodownload"
      :apk="apk"/>

  <div id="page" class="site container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
        
          <!-- Hero Section -->
          <section class="hero-section hero-section--updated">
            <div class="hero-content">
              <h1>GB WhatsApp Download APK –New Version 2026</h1>
              <p class="hero-description">
                Download the latest GB WhatsApp APK for Android and discover additional ways to customize your messaging experience. This page provides the current APK details, main features, and installation information, making it easier to understand what <a href="https://gb-dwnplus.org/" class="jump-url">GBWhatsApp</a> offers before you install it.
              </p>
              <div class="hero-app-card">
                <img src="@/assets/logo.webp" alt="GB WhatsApp app icon" />
              </div>
              <div class="download-button-container">
                <button class="download-btn primary" @click="gotodownload()">
                  GB WhatsApp Download APK (79 MB)
                </button>
              </div>
              <div class="download-support-list" aria-label="Download support information">
                <span><b aria-hidden="true">🔄</b> Regular Updates</span>
                <span><b aria-hidden="true">📖</b> Installation Guide</span>
                <span><b aria-hidden="true">🛡️</b> Privacy Information</span>
              </div>
              <p class="download-check-note">
                Checking the APK information above before downloading to make sure the version is suitable for your device.
              </p>
            </div>
          </section>

          <!-- APK Details Section -->
          <section class="apk-details-section">
            <h2>GB WhatsApp Download APK</h2>
            <div class="apk-details-grid">
              <div class="apk-detail-item">
                <span>Latest Version:</span>
                <strong>18.80</strong>
              </div>
              <div class="apk-detail-item">
                <span>File Size:</span>
                <strong>79 MB</strong>
              </div>
              <div class="apk-detail-item">
                <span>Android:</span>
                <strong>5.0 and higher</strong>
              </div>
              <div class="apk-detail-item">
                <span>Platform:</span>
                <strong>Android</strong>
              </div>
              <div class="apk-detail-item">
                <span>File Type:</span>
                <strong>APK</strong>
              </div>
              <div class="apk-detail-item">
                <span>VirusTotal Scan:</span>
                <strong>Clean</strong>
              </div>
            </div>
          </section>

          <!-- What is GB WhatsApp Section -->
          <section class="what-is-section">
            <h2>What Is GB WhatsApp?</h2>
            <div class="text-content">
              <p>
                <strong>GB WhatsApp</strong> is a modified version of WhatsApp Messenger developed by third-party developers. It provides the familiar messaging experience of WhatsApp while adding additional settings for customization, privacy, and communication.
              </p>
              <p>
                The app supports common WhatsApp functions such as text messaging, voice calls, video calls, and sharing photos, videos, and documents. It also includes additional options that allow users to adjust different parts of the app according to their preferences.
              </p>
            </div>
          </section>

          <div class="hero-image">
            <img src="@/assets/home/home-1.png" alt="GB WhatsApp app preview" />
          </div>

          <!-- Why Choose Section -->
          <section class="why-choose-section">
            <h2>Why Do Users Choose GB WhatsApp?</h2>
            <div class="text-content">
              <p>
                The main attraction of GB WhatsApp is the additional control it gives users over the messaging experience. While the official WhatsApp app focuses on core communication features, <a href="https://gb-dwnplus.org/" class="jump-url">GB WhatsApp app</a> provides more settings for users who want to change the interface, manage privacy preferences, or adjust messaging behavior.
              </p>
              <p>
                For users who enjoy customizing their apps, these additional options can make everyday messaging more flexible and personalized.
              </p>
            </div>
          </section>

          <!-- Important Note Section -->
          <section class="important-note-section">
            <h2>Important Note Before Downloading GBWhatsApp</h2>
            <div class="text-content">
              <ul class="download-note-list">
                <li><strong>Not on Google Play</strong> - Download and install using the APK file.</li>
                <li><strong>Check APK Details</strong> - Verify the version, file size, and Android compatibility.</li>
                <li><strong>Use a Trusted Source</strong> - Avoid unknown or suspicious APK websites.</li>
                <li><strong>Back Up Your Chats</strong> - Save your important WhatsApp conversations before switching.</li>
                <li><strong>Know the Risks</strong> - Unofficial apps may have privacy, security, compatibility, or account risks.</li>
              </ul>
            </div>
          </section>

          <!-- Download Info Section -->
          <section class="download-info-section">
            <h2>GB WhatsApp Download Info</h2>
            <div class="comparison-table">
              <table>
                <thead>
                  <tr>
                    <th>Property</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>App Name</td>
                    <td>GB WhatsApp</td>
                  </tr>
                  <tr>
                    <td>Size</td>
                    <td>79 MB</td>
                  </tr>
                  <tr>
                    <td>Latest Version</td>
                    <td>v18.80</td>
                  </tr>
                  <tr>
                    <td>Android Version</td>
                    <td>Android 5.5 or Higher</td>
                  </tr>
                  <tr>
                    <td>Last Updated</td>
                    <td>5 Hour ago</td>
                  </tr>
                  <tr>
                    <td>Cost</td>
                    <td>FREE</td>
                  </tr>
                  <tr>
                    <td>Total Downloads</td>
                    <td>93,000,000+</td>
                  </tr>
                  <tr>
                    <td>Get it On</td>
                    <td>Google</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="download-buttons">
              <button class="download-btn primary" @click="gotodownload()">
                Download GB WhatsApp Latest Version (18.80)
              </button>

              <button class="download-btn secondary">
                Download GB WhatsApp Old Version
              </button>
            </div>
          </section>

          <!-- Features Section -->
          <section class="features-section">
            <h2>Features Of The GB WhatsApp Latest Version</h2>
            <div class="features-grid">
              <div class="feature-item">
                <h3>Auto Reply</h3>
                <p>The Auto Reply feature on GB WhatsApp lets you automatically send a preset message when someone texts you. You can set it up for specific contacts or groups, use different replies for different people, and schedule it to work at certain times.</p>
              </div>
              <img class="image-style" src="@/assets/home/home-2.webp" alt="GB WhatsApp Features" />
              <div class="feature-item">
                <h3>Fixed Login Issues</h3>
                <p>Previous versions of GBWhatsApp old versions had some login issues that frustrated users. But we have fixed this problem by finding solution for the users, now you can enjoy its new features by downloading GB WhatsApp download 53 MB from our website and now you will not face any kind of problem in logging into your GB WhatsApp Pro update.</p>
              </div>
              <div class="feature-item">
                <h3>Freeze Last Seen</h3>
                <p>Freeze Last Seen feature in GB WhatsApp Pro v18.80 download lets you stop updating your last seen time. This means others will see only the last time you chose to show as active, even if you are actually online.</p>
              </div>
              <img class="image-style" src="@/assets/home/home-3.webp" alt="GB WhatsApp Features" />
              <div class="feature-item">
                <h3>Anti-Ban Protection</h3>
                <p>The updated version of GBWhatsApp download has strong Anti-Ban features to make sure users can use all the extra features without worrying about getting banned. This improvement helps users feel more secure about their account.</p>
              </div>
              <div class="feature-item">
                <h3>Anti-Delete Messages</h3>
                <p>With GB WhatsApp Update anti-delete message feature, you can read messages that your friend sent you, even if they were deleted before you had a chance to see them. This feature allows you to view messages that were originally deleted by the sender.</p>
              </div>
              <img class="image-style" src="@/assets/home/home-4.webp" alt="GB WhatsApp Features" />
              <div class="feature-item">
                <h3>Blue Tick Off</h3>
                <p>In GBWhatsApp, there are an option to read messages without showing the blue tick to the sender. This means you can read their messages without them knowing that you have seen them.</p>
              </div>
              <div class="feature-item">
                <h3>Anti-Delete Status</h3>
                <p>With the help of GB WhatsApp Pro anti-delete status, you will be able to see all the status of your friends and relatives again even if they have deleted the status immediately after putting it on their status.</p>
              </div>
              <img class="image-style" src="@/assets/home/home-5.webp" alt="GB WhatsApp Features" />
              <div class="feature-item">
                <h3>Download Status</h3>
                <p>The Download Status feature on GB WhatsApp 10.20 download lets you save the statuses that your friends post, like photos and videos, directly to your phone. This means you can keep a copy of any status you like without asking the person to send it to you. Just view the status and then use the download option to save it.</p>
              </div>
              <div class="feature-item">
                <h3>Themes Customization</h3>
                <p>GB WhatsApp APK allows users to personalize the appearance of their messaging interface. Unlike the standard WhatsApp, GBWhatsApp 2026 update offers a variety of themes that users can choose from to change the look and feel of their app</p>
              </div>
              <img class="image-style" src="@/assets/home/home-6.webp" alt="GB WhatsApp Features" />
              <div class="feature-item">
                <h3>DND Mode</h3>
                <p>DND mode in GBWhatsApp latest version allows users to silence notifications and messages. When DND mode is activated, users won't receive notifications for new messages or calls, ensuring uninterrupted quiet time. This feature is handy when you need a break from notifications but still want to access the app.</p>
              </div>
              <div class="feature-item">
                <h3>Ghost Mode</h3>
                <p>Ghost Mode in GB WhatsApp download new version lets you use GBWhatsApp secretly. When you turn it on, no one can see if you are online, typing, or if you have read their messages. It gives you more privacy and control, so you can use GB WhatsApp without anyone knowing what you are doing.</p>
              </div>
              <img class="image-style" src="@/assets/home/home-7.webp" alt="GB WhatsApp Features" />
              <div class="feature-item">
                <h3>Improved Media Sharing</h3>
                <p>GBWhatsApp APK download allows for larger file transfers, including videos up to 50 MB and All high-resolution images without compromising quality. This feature is particularly beneficial for users who frequently share media files.</p>
              </div>
            </div>
          </section>

          <!-- Comparison Table Section -->
          <section class="comparison-section">
            <h2>Difference Between GB WhatsApp Vs WhatsApp</h2>
            <div class="comparison-table">
              <table>
                <thead>
                  <tr>
                    <th>Features</th>
                    <th>GB WhatsApp</th>
                    <th>WhatsApp</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Auto Reply</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>Airplane Mode</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>Hide Online</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>DND Mode</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>Forwarding Msg</td>
                    <td>Unlimited</td>
                    <td>5 Chats</td>
                  </tr>
                  <tr>
                    <td>Blue Tick Hide</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>Send Large File</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>Hide View Status</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>Anti-Delete Status</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>See Deleted Msg</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>Themes Change</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>Status Length</td>
                    <td>Maximum 255</td>
                    <td>Maximum 139</td>
                  </tr>
                  <tr>
                    <td>Security Lock</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>Download Status</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                  <tr>
                    <td>Freeze Last Seen</td>
                    <td>√</td>
                    <td>×</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <!-- Installation Guide Section -->
          <section class="installation-section">
            <h2>How to Download and Install GB WhatsApp on Android Devices</h2>
            <div class="text-content">
              <ol class="installation-steps">
                <li>First, click the download button above to get GB WhatsApp 2026 on your phone.</li>
                <li>Next, go to your device settings and allow installations from unknown sources</li>
                <li>Now, Find the downloaded GB WhatsApp APK file and install it on Your Phone.</li>
                <li>Follow the instructions on the screen to finish the installation.</li>
                <li>Open the GBWhatsApp App and verify your phone number by entering the code sent to you via SMS or call.</li>
                <li>Once done, you can start using all the great features of GB WhatsApp download new version On Your Phone.</li>
              </ol>
            </div>
          </section>

          <!-- iOS Section -->
          <section class="ios-section">
            <h2>GB WhatsApp for iPhone/iOS: Availability and Limitations</h2>
            <div class="text-content">
              <p>
                GB WhatsApp is not officially available for iOS (iPhone). It is designed mainly for Android devices. Apple has strict app policies, and modified apps like GB WhatsApp are not allowed on the App Store. However, there are unofficial ways to try using GB WhatsApp on an iPhone, but they come with risks.
              </p>
            </div>
          </section>

          <!-- PC Usage Section -->
          <section class="pc-usage-section">
            <h2>Using GB WhatsApp on PC or Laptop</h2>
            <div class="text-content">
              <p>
                Many people want to use GB WhatsApp on their PC to enjoy the app extra features on a bigger screen. Since GB WhatsApp is mainly made for Android phones, There is no official GB WhatsApp app for PC, so to use it on your laptop, you need an Android emulator like BlueStacks. An emulator lets you run Android apps on your PC. You can install GB WhatsApp inside the emulator and use it like on your phone.
              </p>
            </div>
          </section>

          <!-- Pros and Cons Section -->
          <section class="pros-cons-section">
            <h2>GBWhatsApp Pros And Cons</h2>
            <div class="pros-cons-grid">
              <div class="pros-section">
                <h3>Pros of GB WhatsApp</h3>
                <ul>
                  <li>You can hide your online status, blue ticks, and even typing or recording indicators.</li>
                  <li>You can view others statuses without them knowing.</li>
                  <li>Freeze your last seen time so no one knows when you were last online.</li>
                  <li>Auto-reply when you're busy (like in WhatsApp Business).</li>
                  <li>See deleted messages or statuses that others tried to remove.</li>
                  <li>You can use two WhatsApp numbers on the same phone.</li>
                </ul>
              </div>
              <div class="cons-section">
                <h3>Cons of GB WhatsApp</h3>
                <ul>
                  <li>GB WhatsApp is made by third-party developers, not the real WhatsApp team.</li>
                  <li>It is not available on the Google Play Store, so there are a higher risk of viruses or fake versions.</li>
                  <li>WhatsApp might ban your number if they find out you are using GBWhatsApp.</li>
                </ul>
              </div>
            </div>
          </section>

          <!-- Unban Guide Section -->
          <section class="unban-guide-section">
            <h2>How to Get Unbanned from WhatsApp Quickly</h2>
            <div class="text-content">
              <p>If your WhatsApp account has been banned, follow these steps to restore access as quickly and safely as possible:</p>
              <div class="unban-steps">
                <div class="step">
                  <div class="step-title">Step 1: Uninstall GB WhatsApp</div>
                  <p>If you are using modified versions like GB WhatsApp or WhatsApp Plus, uninstall them immediately. These unauthorized apps are one of the main reasons accounts get banned. Then, download and install the official WhatsApp version from the Google Play Store (Android) or App Store (iPhone).</p>
                </div>
                <div class="step">
                  <div class="step-title">Step 2: Contact WhatsApp Support</div>
                  <p>Open WhatsApp or visit the WhatsApp Support page. Explain your issue politely, mentioning that you will follow WhatsApp's rules moving forward. Being respectful in your request can improve your chances of getting unbanned.</p>
                </div>
                <div class="step">
                  <div class="step-title">Step 3: Send an Email to WhatsApp</div>
                  <p>"If in-app support does not resolve the issue, email WhatsApp support using the email linked to your WhatsApp account and include your phone number with the country code. WhatsApp typically replies within 24–48 hours."</p>
                </div>
                <div class="step">
                  <div class="step-title">Step 4: Wait for Temporary Ban to Expire</div>
                  <p>If your ban is temporary, simply wait for the countdown timer in WhatsApp to expire. Avoid reinstalling or repeatedly logging in, as this may extend the ban period.</p>
                </div>
              </div>
            </div>
          </section>

          <!-- Update Guide Section -->
          <section class="update-guide-section">
            <h2>How to Update GB WhatsApp in 2026</h2>
            <div class="text-content">
              <p>Follow these steps to ensure your GB WhatsApp is up to date:</p>
              <ol class="update-steps">
                <li><strong>Backup Your Chats</strong> - Open GB WhatsApp. Go to Settings > Chats > Chat Backup. Tap BACK UP to save your chats.</li>
                <li><strong>Uninstall the Current Version</strong> - Remove the existing GB WhatsApp app from your device.</li>
                <li><strong>Download the Latest APK Version</strong> - Obtain the latest GB WhatsApp APK file from a trusted source.</li>
                <li><strong>Install the New Version</strong> - Locate the downloaded APK and install it.</li>
                <li><strong>Verify Your Number</strong> - Open GB WhatsApp, enter your phone number, and complete verification.</li>
                <li><strong>Restore Your Chats</strong> - Restore your chat backup after verification.</li>
              </ol>
            </div>
          </section>

          <!-- Safety Section -->
          <section class="safety-section">
            <h2>Is GB WhatsApp Safe?</h2>
            <div class="text-content">
              <p>GB WhatsApp is not developed by WhatsApp Inc., and using it comes with certain risks:</p>
              <ul class="safety-list">
                <li><strong>Reduced Security:</strong> It lacks the strong end-to-end encryption protocols of the official app.</li>
                <li><strong>Account Suspension:</strong> Using GB WhatsApp can lead to temporary or permanent bans.</li>
                <li><strong>Privacy Concerns:</strong> It may request extra permissions that could put personal information at risk.</li>
              </ul>
            </div>
          </section>

          <!-- Conclusion Section -->
          <section class="conclusion-section">
            <h2>Conclusion</h2>
            <div class="conclusion-content">
              <p>
                GB WhatsApp offers a wide range of features and customization options that significantly enhance the messaging experience. With advanced privacy controls, theme personalization, and the ability to share larger media files, it gives users greater control and flexibility. By following the installation steps provided, you can easily download and set up GB WhatsApp APK on your Android device.
              </p>
              <p>
                If you encounter any issues during the download or installation process, feel free to leave a comment in the section below — we're here to help. Thank you for choosing GB WhatsApp for your messaging needs.
              </p>
            </div>
          </section>

        </main> 
      </div>
    </div>
  </div>

  <!-- Fixed Bottom Download Button for Mobile -->
  <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
    GB WhatsApp Download(v18.80)
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import 'swiper/css/swiper.css';

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'home',
      tableHide: true,
      comment: {
        name: '',
        email: '',
        content: '',
      },
      showapk: false,
      showTableOfContents: false,

      apk: null,
      from: 'gb',
      filename: 'gb',
      clickNum: 0,
      selectedLanguage: 'en',
    };
  },
  head() {
    return {
      title: 'GB WhatsApp Download APK V18.80 – New Version Update 2026',
      meta: [
        {
          name: 'description',
          content: 'Download latest version of GB WhatsApp APK with new features. GBWhatsApp will keep updating new customized features for Android users.'
        },
        {
          name: 'keywords',
          content: 'gb whatsapp, gbwhatsapp, gb whatsapp download, gb whatsapp apk, gbwhatsapp app'
        },
        {
          property: 'og:title',
          content: 'GB WhatsApp Download APK V18.80 – New Version Update 2026'
        },
        {
          property: 'og:description',
          content: 'Download latest version of GB WhatsApp APK with new features. GBWhatsApp will keep updating new customized features for Android users.'
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          name: 'twitter:title',
          content: 'GB WhatsApp Download APK V18.80 – New Version Update 2026'
        },
        {
          name: 'twitter:description',
          content: 'Download latest version of GB WhatsApp APK with new features. GBWhatsApp will keep updating new customized features for Android users.'
        }
      ]
    };
  },
  computed: {
    downloadURL() {
      // var params = window.location.search;
      // return `/gbwhatsapp-apk-download${params}`;
      if (typeof window === 'undefined') {
        // Server-side rendering logic
        return '/gbwhatsapp-apk-download'; // Adjust this based on your server-side logic
      } else {
        // Client-side rendering logic
        let params = window.location.search;
        return `/gbwhatsapp-apk-download${params}`;
      }
    },
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }

 

    // window.adsTag.renderInterstitial(54982);
  },
  methods: {
    downloadClick() {
      this.$router.push({
        name: 'en-download'
      });
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      this.$router.push({
        name: 'en-download'
      });
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    jump(url) {
      window.location.href = url;
    },
  
  },
};
</script>

<style scoped>
.image-style {
  width: 400px;
  margin: 0 auto;
}

.hero-section--updated {
  gap: 3rem;
}

#page {
  width: 80%;
  margin: 0 auto;
  max-width: none;
}

#content,
#primary,
#maincontent {
  width: 100%;
}

.hero-app-card {
  width: 220px;
  min-width: 220px;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  background: #f2fff6;
  border: 1px solid #d8f4df;
  border-radius: 14px;
  box-shadow: 0 10px 26px rgba(18, 140, 126, 0.14);
  margin: 0 auto;
}

.hero-app-card img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.download-support-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin: 1rem auto 0;
}

.download-support-list span {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 5px 10px;
  border: 1px solid #d8f4df;
  border-radius: 6px;
  background: #f6fff8;
  color: #155f37;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.2;
}

.download-support-list b {
  margin-right: 5px;
  font-size: 0.9rem;
  line-height: 1;
}

.download-check-note {
  margin: 1rem auto 0;
  color: #5b6660;
  font-size: 1rem;
  line-height: 1.6;
  text-align: center;
}

.apk-details-section {
  background: #f8f9fa;
  border-radius: 15px;
  padding: 3rem;
}

.apk-details-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 2rem;
}

.apk-detail-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 88px;
  padding: 1rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.apk-detail-item span {
  color: #333;
  font-weight: 700;
}

.apk-detail-item strong {
  color: #25D366;
  text-align: right;
}

.download-note-list {
  display: grid;
  gap: 1rem;
  padding: 0;
  margin: 0;
  list-style: none;
}

.download-note-list li {
  padding: 1rem;
  background: #fff;
  border-left: 4px solid #25D366;
  border-radius: 8px;
  color: #555;
  line-height: 1.6;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  list-style: none !important;
}

/* Hero Section */
.hero-section {
  display: flex;
  align-items: center;
  padding: 2rem 0;
}

.hero-content {
  flex: 1;
}

.hero-content h1 {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  position: relative;
  padding-left: 0;
  text-align: center;
}

.hero-content h1::before {
  content: none;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

.hero-description {
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.hero-image {
  width: 100%;
  max-width: 100%;
  margin: 1.5rem auto 0;
  padding: 0;
  text-align: center;
}

.hero-image img {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

.download-button-container {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
}

.download-btn {
  padding: 15px 30px;
  font-size: 1.1rem;
  font-weight: bold;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  margin: 0 auto;
}

.download-btn.primary {
  background: #FF6B35;
  color: white;
  box-shadow: 0 5px 15px rgba(255, 107, 53, 0.4);
}

.download-btn.primary:hover {
  background: #E55A2B;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 107, 53, 0.6);
}

.download-btn.secondary {
  background: transparent;
  color: #25D366;
  border: 2px solid #25D366;
}

.download-btn.secondary:hover {
  background: #25D366;
  color: white;
}

/* Content Sections */
section {
  width: 100%;
  box-sizing: border-box;
  padding: 2rem 0;
  margin: 0 auto;
  max-width: 100%;
}

section h2 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 2rem;
  /* text-align: center; */
  color: #333;
  position: relative;
  padding-left: 20px;
}

section h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

.text-content {
  margin-top: 2rem;
}

.text-content p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: #555;
}

/* Download Info Section */
.download-info-section {
  background: #f8f9fa;
  border-radius: 15px;
  padding: 3rem;
}

.info-table {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
  margin: 2rem 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.info-row .label {
  font-weight: bold;
  color: #333;
}

.info-row .value {
  color: #25D366;
  font-weight: bold;
}

.download-buttons {
  text-align: center;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Features Section */
.features-section {
  background: #f8f9fa;
  border-radius: 15px;
  padding: 3rem;
}

.features-grid {
 display: flex;
 flex-direction: column;
  gap: 2rem;
  margin-top: 2rem;
}

.feature-item {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.08);
  transition: transform 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
}

.feature-item h3 {
  color: #25D366;
  font-size: 1.3rem;
  margin-bottom: 1rem;
  font-weight: bold;
  position: relative;
  padding-left: 15px;
}

.feature-item h3::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

.feature-item p {
  color: #666;
  line-height: 1.6;
}

/* Comparison Table */
.comparison-section {
  background: white;
  border-radius: 15px;
  padding: 3rem;
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
}

.comparison-table {
  overflow-x: auto;
  margin-top: 2rem;
}

.comparison-table table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.comparison-table th {
  background: #25D366;
  color: white;
  padding: 1rem;
  font-weight: bold;
  text-align: center;
}

.comparison-table td {
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.comparison-table tr:nth-child(even) {
  background: #f8f9fa;
}

.comparison-table tr:hover {
  background: #e8f5e8;
}

/* Installation Steps */
.installation-steps {
  font-size: 1.1rem;
  line-height: 1.8;
}

.installation-steps li {
  margin-bottom: 1rem;
  padding-left: 1rem;
}

/* Pros and Cons */
.pros-cons-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 3rem;
  margin-top: 2rem;
}

.pros-section, .cons-section {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.08);
}

.pros-section h3 {
  color: #25D366;
  margin-bottom: 1rem;
  position: relative;
  padding-left: 15px;
}

.pros-section h3::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

.cons-section h3 {
  color: #dc3545;
  margin-bottom: 1rem;
  position: relative;
  padding-left: 15px;
}

.cons-section h3::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(to bottom, #dc3545, #c82333);
  border-radius: 2px;
}

.pros-section ul, .cons-section ul {
  list-style: none;
  padding: 0;
}

.pros-section li, .cons-section li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
  position: relative;
  padding-left: 1.5rem;
  list-style: none !important;
}

.pros-section li:before {
  content: "✓";
  color: #25D366;
  font-weight: bold;
  position: absolute;
  left: 0;
}

.cons-section li:before {
  content: "✗";
  color: #dc3545;
  font-weight: bold;
  position: absolute;
  left: 0;
}

/* Unban Steps */
.unban-steps {
  margin-top: 2rem;
}

.step {
  background: white;
  padding: 1.5rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  border-left: 4px solid #25D366;
  .step-title {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
}

.step h3 {
  color: #25D366;
  margin-bottom: 0.5rem;
}

/* Update Steps */
.update-steps {
  font-size: 1.1rem;
  line-height: 1.8;
}

.update-steps li {
  margin-bottom: 1rem;
  padding-left: 1rem;
}

/* Safety List */
.safety-list {
  list-style: none;
  padding: 0;
}

.safety-list li {
  padding: 1rem;
  margin-bottom: 1rem;
  background: #fff3cd;
  border-left: 4px solid #ffc107;
  border-radius: 5px;
  list-style: none !important;
}

/* Conclusion */
.conclusion-content {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 10px;
}

.conclusion-content p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1rem;
  color: #555;
}

/* Fixed Bottom Button */
.fix-bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #25D366;
  color: white;
  padding: 1rem;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  z-index: 1000;
  box-shadow: 0 -5px 15px rgba(0,0,0,0.2);
}

/* Responsive Design */
@media (max-width: 768px) {
  #page {
    width: 100%;
  }

  .hero-section {
    flex-direction: column;
    text-align: center;
    padding: 2rem 1rem;
  }

  .hero-app-card {
    width: 180px;
    min-width: 180px;
    padding: 22px;
  }

  .download-support-list {
    justify-content: center;
  }

  .apk-detail-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .apk-detail-item strong {
    text-align: left;
  }
  
  .hero-content h1 {
    font-size: 2rem;
  }
  
  
  .features-grid {
    grid-template-columns: 1fr;
  }
  
  .pros-cons-grid {
    grid-template-columns: 1fr;
  }
  
  .info-table {
    grid-template-columns: 1fr;
  }
  
  section {
    padding: 2rem 1rem;
  }
  
  .download-info-section,
  .features-section,
  .comparison-section {
    padding: 2rem 1rem;
  }
}

@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 1.5rem;
  }
  
  .hero-description {
    font-size: 1rem;
  }
  
  .download-btn {
    padding: 12px 24px;
    font-size: 1rem;
  }
  
  section h2 {
    font-size: 1.8rem;
  }
}
</style>
